module.exports = __webpack_public_path__ + "img/AT.0447178b.svg";